import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { TimeOfDayFilterControl } from "@/components/AgendaFilters";
import { useDepartmentGolfFacilitiesStartEndTime } from "@/features/Department";

import { DepartmentAvailabilityTimeSliderFragment_department$key } from "./__generated__/DepartmentAvailabilityTimeSliderFragment_department.graphql";

type Props = {
  timeRange: { timeGTE?: string; timeLTE?: string } | undefined;
  departmentRef: DepartmentAvailabilityTimeSliderFragment_department$key | null;
  onChange: (value: { timeGTE?: string; timeLTE?: string }) => void;
};

export const DepartmentAvailabilityTimeSlider = ({
  departmentRef,
  timeRange,
  onChange,
}: Props) => {
  const department = useFragment(
    DepartmentAvailabilityTimeSliderFragmentString,
    departmentRef
  );

  const departmentStartEndTime = useDepartmentGolfFacilitiesStartEndTime(
    department ?? null
  );

  return (
    <TimeOfDayFilterControl
      controlStartTime={departmentStartEndTime?.startTime}
      controlEndTime={departmentStartEndTime?.endTime}
      onChange={onChange}
      selectedTimeRange={timeRange}
    />
  );
};

const DepartmentAvailabilityTimeSliderFragmentString = graphql`
  fragment DepartmentAvailabilityTimeSliderFragment_department on Department {
    ...useDepartmentGolfFacilitiesStartEndTime_department
  }
`;
